import React from 'react';
import { Block } from '../../../../../../components';
import clockIcon from '../../../../../../../assets/icons/icon-clock-black.svg';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../assets/icons/icon-line.svg';
import Spinner from '../../../../../../components/Spinner';
import ModalExist from '../../../../components/Modal/Modal';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import { SubContainer } from '../../../certificates-constancies/type1/info/components';
import { BtnRequest } from '../../IssuanceUniversityCard/info/components/styled';
import { List } from '@/presentation/reusables/components/List';
import ProgressBody from '../components/ProgressBody';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';

const UpdatePhotoInfoView = (props: any) => {
  const {
    procedureSelectedInfo,
    showModalConfirmation,
    handleBack,
    handleNewRequest,
    handleExistRequest,
    handleCloseModalConfirmation
  } = props;

  const preRequest = () => {
    handleNewRequest(procedureSelectedInfo.isValidatedStudentFoto);
  };

  return (
    <ModuleContainer
      containerType="subsection"
      data-testid="cmp-update_photo_info_view"
    >
      <SubsectionHeader
        title="Registro / Actualización de fotografía"
        onClick={handleBack}
      />
      <SubContainer>
        {!procedureSelectedInfo && <Spinner />}
        {procedureSelectedInfo && (
          <>
            <Block
              customized
              flexDirection="row"
              alignItems="center"
              margin="0px 0px 0px 0px"
            >
              <ProgressBody
                moneyIcon={moneyIcon}
                procedureSelectedInfo={procedureSelectedInfo}
                lineIcon={lineIcon}
                clockIcon={clockIcon}
              />
            </Block>
            <div
              style={{
                backgroundColor: 'white',
                margin: '24px 0 0 0',
                padding: '8px 16px 8px 8px',
                borderRadius: '8px',
                boxShadow: '0px 2px 8px -4px rgba(176, 192, 202, 0.20)'
              }}
            >
              <List />
            </div>
            <BtnRequest
              data-testid="cmp-btnrequest-change"
              onClick={preRequest}
            >
              <p>Empezar solicitud</p>
            </BtnRequest>
            <ModalExist
              show={showModalConfirmation}
              handleClose={handleCloseModalConfirmation}
            >
              <RequestExist handleClick={handleExistRequest} />
            </ModalExist>
          </>
        )}
      </SubContainer>
    </ModuleContainer>
  );
};

export default UpdatePhotoInfoView;
